export const CYPRESS_MOCK_EXTENSION = "CypressMockExtension";
